import {Injectable } from "@angular/core";
import { ValApiResultat, ValBaseService } from "../../../../val-ammon-services/val-services-communs-lib/src/public-api";
import { ValAppSettingsService } from "../../../../val-ammon-services/val-app-settings-lib/src/public-api";
import { RetournerVueAchatResultat } from "./RetournerVueAchatResultat";
import { RetournerVueAchatDocumentResultat } from "./RetournerVueAchatDocumentResultat";
import { RetournerVueAchatHistoriqueStatutResultat } from "./RetournerVueAchatHistoriqueStatutResultat";
import { RetournerDocumentAchatResultat } from "./RetournerDocumentAchatResultat";
import { FiltreAccueilPeriode } from "./FiltreAccueilPeriode";
import { RetournerStatistiquesFacturesRecuesResultat } from "./RetournerStatistiquesFacturesRecuesResultat";
import { RetournerStatistiquesSuiviRegularisationsAchatResultat } from "./RetournerStatistiquesSuiviRegularisationsAchatResultat";
import { RetournerStatistiquesRepartitionParStatutAchatResultat } from "./RetournerStatistiquesRepartitionParStatutAchatResultat";

//eFact achat service
@Injectable (
{
  providedIn: 'root'
})
export class EFactAchatService extends ValBaseService 
{
  //Création
  //  Paramètres
  //    appSettingsService : Service d’accès à la configuration de l’application
  constructor (private appSettingsService: ValAppSettingsService) 
  {
    super ();
  }

  //Url de base
  protected override get BaseUrl () : string 
  {
    return `${this.appSettingsService.Configuration.UrlApi.EFact}/v1.0/achat/`;
  }

  //Retourne la vue d'un achat
  //  Paramètres
  //    id : Identifiant de l'achat
  //  Retourne
  //    Résultat de la récupération de la vue de l'achat
  public async RetournerVueAchat (id: string) : Promise<ValApiResultat<RetournerVueAchatResultat>> 
  {
    let operation: Promise<ValApiResultat<RetournerVueAchatResultat>>;
    let url: string;

    url = `${id}/vue`;
    
    operation = this.ExecuterRequeteGet<RetournerVueAchatResultat> (url);

    return operation
  }
  
  // Retourne la vue des documents liés à un achat
  public async RetournerVueAchatDocuments(id: string): Promise<ValApiResultat<RetournerVueAchatDocumentResultat[]>> {
    const url = `${id}/vue/documents`;
    return this.ExecuterRequeteGet<RetournerVueAchatDocumentResultat[]>(url);
  }
  
  // Retourne l'historique des statuts d'une facture d'achat, du plus récent au plus ancien
  public async RetournerVueAchatHistoriqueStatuts(id: string): Promise<ValApiResultat<RetournerVueAchatHistoriqueStatutResultat[]>> {
    const url = `${id}/vue/historique-statuts`;
    return this.ExecuterRequeteGet<RetournerVueAchatHistoriqueStatutResultat[]>(url);
  }
  
  // Retourne le contenu d'un document lié à un achat
  public async RetournerDocumentAchat(id: string, idDocument: string): Promise<ValApiResultat<RetournerDocumentAchatResultat>> {
    const url = `${id}/documents/${idDocument}`;
    return this.ExecuterRequeteGet<RetournerDocumentAchatResultat>(url);
  }

  // Retourne tous les documents liés à un achat dans un zip
  public async RetournerDocumentsAchatZip(id: string): Promise<ValApiResultat<RetournerDocumentAchatResultat>> {
    const url = `${id}/documents`;
    return this.ExecuterRequeteGet<RetournerDocumentAchatResultat>(url);
  }

  // Retourne les statistiques des factures reçues
  public async RetournerStatistiquesFacturesRecues(filtre: FiltreAccueilPeriode): Promise<ValApiResultat<RetournerStatistiquesFacturesRecuesResultat>> {
    const url = `statistics/received-invoices?period=${filtre}`;
    return this.ExecuterRequeteGet<RetournerStatistiquesFacturesRecuesResultat>(url);
  }

  // Retourne les statistiques du suivi des régularisations
  public async RetournerStatistiquesSuiviRegularisations(filtre: FiltreAccueilPeriode): Promise<ValApiResultat<RetournerStatistiquesSuiviRegularisationsAchatResultat>> {
    const url = `statistics/regularization-tracking?period=${filtre}`;
    return this.ExecuterRequeteGet<RetournerStatistiquesSuiviRegularisationsAchatResultat>(url);
  }

  // Retourne la répartition des factures d'achats par thématique de statut
  public async RetournerStatistiquesRepartitionParStatut(filtre: FiltreAccueilPeriode): Promise<ValApiResultat<RetournerStatistiquesRepartitionParStatutAchatResultat>> {
    const url = `statistics/status-breakdown?period=${filtre}`;
    return this.ExecuterRequeteGet<RetournerStatistiquesRepartitionParStatutAchatResultat>(url);
  }
}
